import styled from 'styled-components';

export const OrglessHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0 30px;
    width: 100%;
    height: 50px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
`;

export const AccessDeniedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 100px);
  padding: 20px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#0f1419' : '#ffffff')};
`;

export const AccessDeniedContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: 800px;
  height: 300px;
  padding: 20px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
  border-radius: 6px;
  border: ${({ theme }) => (theme.mode === 'dark' ? '1px solid #374151' : 'none')};
  box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 4px 24px rgba(255, 255, 255, 0.08)'
    : '0 4px 24px rgba(224, 123, 45, 0.15)')};
`;

export const LogoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40%;
    height: 200px;
    border-right: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#ccc')};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 50px;
`;

export const Title = styled.h1`
    font-size: 2em;
    font-weight: 500;
    line-height: 1.2;
    margin: 40px 0 12px 0;
    text-align: center;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#000000')};
`;

export const Description = styled.p`
    font-size: 14px;
    margin: 0;
    text-align: center;
    max-width: 464px;
    font-weight: 400;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#52525B')};

    strong {
        color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#000000')};
    }
`;

export const ContactText = styled.p`
    font-size: 20px;
    line-height: 1.2;
    margin-top: 40px;
    margin-bottom: 12px;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#000000')};
    text-align: center;
    a {
        text-align: center;
        color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#52525B')};
        text-decoration: underline;
        margin: 0 5px;
    }
`;

export const Contact = styled.span`
    color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#52525B')};
    font-size: 18px;
    line-height: 1.2;
    font-weight: 400;
    margin-bottom: 40px;
    text-align: center;
`;

export const Link = styled.a`
    color: #C18244;
    font-size: 18px;
    line-height: 1.2;
    font-weight: 400;
    text-decoration: underline;
`;

export const Button = styled.button`
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#1a4d4d' : '#000000')};
    width: 220px;
    height: 48px;
    border-radius: 50px;
    color: #FFFFFF;
    font-size: 18px;
    line-height: 1.2;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background-color: ${({ theme }) => (theme.mode === 'dark' ? '#0f3333' : '#333333')};
    }
`;

export const OrglessFooter = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
    padding: 0 30px;
    border-top: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f5f5f5')};
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};

    a {
        color: ${({ theme }) => (theme.mode === 'dark' ? '#6b7280' : '#989898')};
        font-size: 12px;
        line-height: 1.7;
        position: relative;
        &:not(:last-child) {
            &:after {
                content: '|';
                margin-left: 10px;
                margin-right: 10px;
            }
        }
        &:hover {
            color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#4b4949')};
            text-decoration: underline;
        }
    }
`;
